/*
 *   File : tab.js
 *   Author : https://evoqins.com
 *   Description : tab component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect, useRef, useState } from "react";
import styles from "../../Style/Components/tab.module.scss";

export default function Tabs({
  bottomBorder = true,
  data = [],
  defaultActive = null,
  labelStyle,
  onChange = () => {},
  wrapperClass = "",
}) {
  const [activeTab, setActiveTab] = useState(defaultActive);
  const tabsRef = useRef([]);
  const containerRef = useRef(null);
  const handleSelect = (id) => {
    setActiveTab(id);
    onChange(id); // expose to parent
  };
  useEffect(() => {
    setActiveTab(defaultActive);
  }, [defaultActive]);
  return (
    <div className={`position-relative ${wrapperClass}`}>
      <div
        ref={containerRef}
        className="d-flex flex-nowrap overflow-auto hide-scrollbar"
        style={{ scrollBehavior: "smooth" }}
      >
        {/* INNER WRAPPER TO AUTO-SHRINK TO TABS WIDTH */}
        <div className="d-flex col-g-24 w-max-content position-relative">
          {data.map((item, index) => {
            const isActive = item.id === activeTab;

            return (
              <div
                key={item.id}
                ref={(el) => (tabsRef.current[index] = el)}
                className={`${styles.e_tab_wrapper} ${
                  isActive ? "pe-0" : ""
                } w-max-content e-cursor-pointer`}
                onClick={() => handleSelect(item.id)}
              >
                <div
                  className={`
                ${styles.e_tab} ${
                  labelStyle ? labelStyle : "fw-500 fs-18 lh-20"
                }  py-10
                w-max-content
                ${isActive ? styles.e_active_tab : styles.e_inactive_tab}
                ${isActive ? `text-facebook-blue` : "text-eerie-black"}
              `}
                >
                  {item.name}
                </div>
              </div>
            );
          })}

          {bottomBorder && (
            <div className="bg-white h-2 w-100 position-absolute bottom-0 rounded-pill" />
          )}
        </div>
      </div>
    </div>
  );
}
